import React, { useEffect, useState } from 'react'
import IconButton from '@mui/material/IconButton';
import { Link, useParams } from 'react-router-dom'
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useMsal } from "@azure/msal-react";
import './tool.css'
import UnlinkedSection from '../components/UnlinkedSection';
import ExpandIcon from '@mui/icons-material/Expand';
import DropSection from '../components/DropSection';
import ToolNavigation from '../components/ToolNavigation';
import ToolSummary from '../components/ToolSummary';
import { Resizable } from 'react-resizable';
import 'react-resizable/css/styles.css';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
function BudgetingToolPage() {
  const { instance, accounts } = useMsal();
  const name = accounts[0].name;
  const email = accounts[0].username;
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState({})
  const [refresh, setRefresh] = useState(false)
  const [expandAll, setExpandAll] = useState(true);
  const [expandTravel, setExpandTravel] = useState(true);
  const [expandSub, setExpandSub] = useState(true);
  const [expandOther, setExpandOther] = useState(true);
  const [expandReim, setExpandReim] = useState(true);
  const [toggle, setToggle] = useState(false)
  const [openPopupEdit, setOpenPopupEdit] = useState(false);
  const [openPopupAdd, setOpenPopupAdd] = useState(false);
  const [first, setFirst] = useState(true)
  const { id, category } = useParams();
  const [openSummary, setOpenSummary] = useState(false);
  const [expanded, setExpanded] = useState(true);
  const [width, setWidth] = useState(430); // Initial width
  const [height, setHeight] = useState(430);

  useEffect(() => {
    const formatData = async () => {
      //  const c = await getClient();
      const a = await getData1();
      setLoading(false)

      // const b = await getProjects();

    }
    formatData().catch(console.error);

  }, [refresh])



  if (!['Travel', "Non-billable Expenses", "Billable Expenses"].includes(category)) {
    return <>Error</>
  }
  let errors = 0;

  const setErrors = () => {
    errors++;

  }
  const updateError = () => {
    console.log(errors / 4)
  }
  const getData1 = async () => {
    await fetch('/api-dev/expenses/GetTaskData/' + id, {
      method: "POST",
      body: JSON.stringify({ user: name === 'Seddik Houimli' ? 'Thomas Tanghe' : name, category: category, email: email }),
      headers: { 'Content-Type': 'application/json' },
    })
      .then(res => res.json())
      .then(data => setData(data)).then((e) => setLoading(false)).then((e) => console.log('fetched data'))
  }



  if (loading) {

    // console.log(data)
    return <div className='spinner'>
      <Box sx={{ display: 'flex' }} style={{ margin: '40px', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    </div>;

  } else {
    let { info, expenses, budget, mainBudget, budgetFormatted, expenseFormatted, entities } = data
    function handleOnDragEnd(result) {
      console.log(result)
      if (!result.destination) return;
      if (result.source.droppableId === result.destination.droppableId) {
        const items = Array.from(expenseFormatted[result.source.droppableId]);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        expenseFormatted[result.source.droppableId] = items;
        setData({ ...data, expenseFormatted: expenseFormatted })
      } else {
        const itemsSource = Array.from(expenseFormatted[result.source.droppableId]);
        const itemsDestination = Array.from(expenseFormatted[result.destination.droppableId]);
        const [reorderedItem] = itemsSource.splice(result.source.index, 1);
        itemsDestination.splice(result.destination.index, 0, reorderedItem);
        expenseFormatted[result.source.droppableId] = itemsSource;
        expenseFormatted[result.destination.droppableId] = itemsDestination;
        setData({ ...data, expenseFormatted: expenseFormatted })
        if (result.destination.droppableId === 'Unlinked') {
          fetch('/api-dev/expenses/DropExpense/' + (reorderedItem.ExpenseID - 0), {
            method: "POST",
            body: JSON.stringify({ BudgetLine: null }),
            headers: { 'Content-Type': 'application/json' },
          }).then((e) => console.log("updated in database"))
        } else {
          fetch('/api-dev/expenses/DropExpense/' + (reorderedItem.ExpenseID - 0), {
            method: "POST",
            body: JSON.stringify({ BudgetLine: result.destination.droppableId - 0 }),
            headers: { 'Content-Type': 'application/json' },
          }).then((e) => console.log("updated in database"))
        }
      }
      return;

    }
    

    
    if (!info) {
      return <>You don't have the access rights for this project</>
    }
    return (
      <div className='page-layout'>
        <ToolNavigation
          projectName={info.ProjectName}
          taskName={info.TaskName}
          category={category}
          taskID={info.TaskID}
          projectID={info.ProjectID}
        />
        <ToolSummary
          openPopup={openPopupAdd}
          setOpenPopup={setOpenPopupAdd}
          setRefresh={setRefresh}
          setLoading={setLoading}
          taskID={info.TaskID}
          category={category}
          mainBudget={mainBudget}
          budget={budget}
          expenses={expenses}
        />
        <div  className='tool-container-tool'>
          <DragDropContext onDragEnd={handleOnDragEnd}>
       <UnlinkedSection
              expenses={expenseFormatted['Unlinked']}
              sumExpenses={expenseFormatted['Unlinked'].reduce((a, b) => a + (b['Input'] || 0), 0)}
              width={width}
              height={height}
            />

           
            <div  className='tool-drop-tool' >
              <DropSection
                budgetFormatted={budgetFormatted}
                expenseFormatted={expenseFormatted}
                mainBudget={mainBudget}
                budget={budget}
                expenses={expenses}
                refresh={refresh}
                setRefresh={setRefresh}
                openPopup={openPopupEdit}
                setOpenPopup={setOpenPopupEdit}
                setLoading={setLoading}
                category={category}
                taskID={info.TaskID}
                expanded={expanded}
              />
            </div>

          </DragDropContext>

          <div className='expand-button'>
          <IconButton onClick={() => setExpanded(prev => !prev)} aria-label="delete">
            <ExpandIcon />
          </IconButton>
          </div>
        </div>
        
      </div>

    )
  }

}
export default BudgetingToolPage